<template>
  <div class="cont">
  <div class="toutu">
    <img src="../../assets/fuli.jpg"></div>
  <div class="div_t">
    <div style="text-align: center;">
	<span class="hyfl">&nbsp;会员福利</span><br>
	<span style="color:#ffcb8d;"><span style="font-family: 微软雅黑; font-size: 16px;">—————————————————————————————————————————————————————</span></span><br>
	
	<span class="hy_next"><strong>优质燕窝，优先分配</strong><br>
	<br>
	会员享受燕窝优先分配<br>
	<br>
	精选上乘的优质燕窝<br>
	<br>
	优先送到会员的手中<br>
	<br>
	给你更好的品质<br>
	<br>
	<img alt="" src="../../assets/1-1Z52F94443337.jpg" style="width: 788px; "></span>
	<span class="hy_next"><strong>客服指导，优先解答</strong><br>
	<br>
	燕窝之前的疑问谁来解答？<br>
	<br>
	燕窝收到货以后怎么做？<br>
	<br>
	做燕窝遇到问题怎么办？<br>
	<br>
	还有应季的燕窝食谱、吃菜搭配……<br>
	<br>
	会员一对一指导，优先解答<br>
	<br>
	给你最好的服务！<br>
	<br>
	<img alt="" src="../../assets/1-1Z6041421345N.jpg" style="width: 788px; height: 526px;"><br>
	<br>
	<strong>专属福利，乐享不停</strong><br>
	<br>
	会员不定时送礼物<br>
	<br>
	炖煮工具、食材礼包赠送<br>
	<br>
	大额优惠券放送<br>
	<br>
	新品尝鲜福利价<br>
	<br>
	性价比限量燕窝优先得<br>
	<br>
	更多专享福利等你解锁！<br>
	<br>
	<img alt="" src="../../assets/1-1Z52F94634359.png" style="width: 782px; height: 490px;"></span><br>
	&nbsp;</div>
<div style="text-align: center;">
	<span class="hy_next"><strong>全年保价，不受市场影响</strong><br>
	<br>
	过去几年燕窝一直在涨<br>
	<br>
	17年价格甚至翻倍<br>
	<br>
	之后可能还会涨，<br>
	<br>
	燕铺承诺所有特权会员<br>
	<br>
	即使未来燕窝价格持续上涨<br>
	<br>
	特权会员全年享受最低价<br>
	<br>
	不受市场涨价影响<br>
	<br>
	<img alt="" src="../../assets/1-1Z52F95Q6409.jpg" style="width: 788px; height: 406px;"><br>
	<br>
	<strong>转介绍福利</strong><br>
	<br>
	会员介绍身边朋友购买<br>
	<br>
	朋友享受会员超低价格<br>
	<br>
	这还不够！<br>
	<br>
	双方均可获得价值188元燕窝胶原蛋白一盒<br>
	<br>
	<img alt="" src="../../assets/1-1Z52F95U3E1.jpg" style="width: 788px; height: 406px;"><br>
	<br>
	<strong>会员专享定制</strong><br>
	<br>
	私人定制燕窝食谱<br>
	<br>
	私人定制待产包<br>
	<br>
	孕期各阶段营养汤<br>
	<br>
	孕期、哺乳期疑问解答<br>
	<br>
	孕期阶段瑜伽分享<br>
	<br>
	产后快速恢复秘籍<br>
	<br>
	高级营养师在线直播<br>
	<br>
	这些哪里有？<br>
	<br>
	成为会员应有尽有<br>
	<br>
	<img alt="" src="../../assets/1-1Z604142015V6.jpg" style="width: 788px; height: 443px;"><br>
	<br>
	<br>
	<strong>燕铺</strong><br>
	<br>
	<strong>专注品质与服务</strong><br>
	<br>
	<strong>我的坚持 你的心意</strong><br>
	<br>
	<strong>不忘初衷</strong><br>
	<br>
	<strong>我在这里等你</strong><br>
	<br>
	<strong>更多会员福利等你来解锁</strong></span><br>
	<br>
	&nbsp;</div>

  </div>
</div>
</template>

<script>
	
export default {
  name: 'vipHyfl',
  data () {
    return {
      
    }
  },
  methods:{
			
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div_t {
    width: 1120px;
    margin: auto;
    margin-top: 84px;
    margin-bottom: 86px;
}
.hy_next{ font-size: 20px; margin-top: 50px; display: block;}
.hyfl{ font-size: 26px;}
.toutu {
    width: 1120px;
    margin: auto;
}

.toutu img {
    width: 100%;
}

.cont {
    width: 1120px;
    margin: 0 auto;
    height: 100%;

}

.logo {
    margin-left: 449px;
    margin-top: 72px;
}


.div_t_div {
    width: 1120px;
    height: 500px;
    position: relative;
}

.div_t_div_img1 {
    width: 500px;
    position: absolute;
}

.div_t_div_img2 {
    position: absolute;
    margin-left: 400px;
    top: 62px;
    z-index: 1;
    height: 280px;
    width: 700px;
}

.text1 {
    position: absolute;
    margin-left: 580px;
    top: 94px;
    z-index: 3;
    width: 500px;
}

.text1 li {
    display: block;
    font-size: 26px;
    letter-spacing: 3px;
    color: #1b1b1b;
    margin-left: 0px;
}

.hrs {
    height: 1px;
    border: none;
    border-top: 1px solid #35b597;
    width: 426px;
    margin-left: 0px;
    margin-top: 16px;
    float: left;
}

.text1_p {
    font-size: 16px;
    text-indent: 2em;
    float: right;
    margin-right: 50px;
    margin-top: 10px;
    line-height: 39px;
    color: #1b1b1b;
    letter-spacing: 1px;
}

.div_c {
    width: 1120px;
    margin: 0 auto;
    margin-top: 0px;
    height: 500px;
    position: relative;
}

.div_c_img1 {
    width: 500px;
    margin-left: 620px;
    position: absolute
}

.div_c_img2 {
    position: absolute;
    top: 50px;
    z-index: 1;
    height: 280px;
    margin-left: 50px;
    width: 700px;
}

.text2 {
    position: absolute;
    /*margin-left: 100px;*/
    top: 82px;
    z-index: 3;
    width: 500px;
}

.text2_li {
    display: block;
    font-size: 26px;
    letter-spacing: 5px;
    color: #1b1b1b;
}

.text2_p {
        font-size: 16px;
    text-indent: 2.3em;
    line-height: 39px;
    color: #1b1b1b;
    margin-top: 32px;
    margin-left: 0px;
    letter-spacing: 3px;
}
@media(max-width: 750px) {
   .cont{width:100%; margin: 0 auto;}
   .toutu{ width: 100%; overflow: hidden}
   .toutu img{ width: 100%; margin-left: 0%;}
  .div_t{ width: 690px; margin: 0 auto; overflow: hidden;}
	.hyfl{ font-size: 32px; display: block; margin-top: 30px;}
	.hy_next{ margin-top: 30px; font-size: 28px}
	.hy_next img{ max-width: 100%;}
 
}     
</style>



// WEBPACK FOOTER //
// src/components/vip/hyfl.vue